<div class="mega-menu-container" [ngClass]="{ 'mega-menu-container--ltr': isLTR }">
  <app-category-list (categoryHoveredEmitter)="onCategoryHovered($event)"></app-category-list>
  <app-subcategories-list
    *ngIf="shouldDisplaySideMenu"
    [hoveredCategoryId]="hoveredCategoryId"
  ></app-subcategories-list>
</div>
